import * as icons from '@creditornot/alchemy-react/icons';
import { IconButton } from '@creditornot/cb-button';
import { scrollToTop } from 'common/utils/scrollUtils';

import { useContentScroll } from '../../../hooks/useContentScroll';
import { AnimatedComponent } from '../AnimatedComponent';

export const MobileSearchButton = () => {
  const contentScroll = useContentScroll();
  return (
    <AnimatedComponent
      isVisible={contentScroll > 0}
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.15 } }}
    >
      <IconButton
        size="small"
        variant="neutral"
        onClick={() => scrollToTop()}
        icon={icons.magnifyingGlass}
      />
    </AnimatedComponent>
  );
};
